import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@cmps/ng-bootstrap';
import { NgChartModule } from '@cmps/ng-chart';
import { SelectModule } from '@cmps/ng-select';
import { CmpsIconModule, CmpsTooltipModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsInsightModule } from '../insight/insight.module';

import { CategoryPerformanceInsightComponent } from './category.pi.component';
import { GridPerformanceInsightComponent } from './grid.pi.component';
import { LevelOptionPerformanceInsightComponent } from './level-option.pi.component';
import { PerformanceInsightComponent } from './performance-insight.component';
import { TranslationIdMap } from './performance-insight.i18n';
import { TrendPerformanceInsightComponent } from './trend.pi.component';
import { VisualPerformanceInsightComponent } from './visual.pi.component';
import { WizardPerformanceInsightComponent } from './wizard.pi.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        SelectModule,
        NgChartModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsInsightModule,
        CmpsIconModule,
        CmpsTooltipModule,
    ],
    declarations: [
        CategoryPerformanceInsightComponent,
        WizardPerformanceInsightComponent,
        LevelOptionPerformanceInsightComponent,
        VisualPerformanceInsightComponent,
        GridPerformanceInsightComponent,
        TrendPerformanceInsightComponent,
        PerformanceInsightComponent,
    ],
    exports: [PerformanceInsightComponent, WizardPerformanceInsightComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CmpsPerformanceInsightModule {}
